export default __webpack_public_path__ + "static/media/blueSimpleBoat.f7e7ad3f.svg";